import { render, staticRenderFns } from "./tabel.vue?vue&type=template&id=1d317197&scoped=true&"
import script from "./tabel.vue?vue&type=script&lang=js&"
export * from "./tabel.vue?vue&type=script&lang=js&"
import style0 from "./tabel.vue?vue&type=style&index=0&id=1d317197&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d317197",
  null
  
)

export default component.exports